export default __webpack_public_path__ + "static/media/detox3.54347212.jpg";